import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '@/config/query-client';

import { uploadTemplate as uploadTemplateAPI } from '@/api/v4/template.api';

export const useUploadTemplate = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: uploadTemplateAPI,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKey.Templates] });
    },
  });

  return {
    uploadTemplate: mutation.mutateAsync,
  };
};
